document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("locationFormSubmit", (e) => {
    const url = e.detail.geoItem.url;
    const params = new URLSearchParams({
      adults: e.detail.adults,
      kids: e.detail.kids,
      dogs: e.detail.dogs,
      bookingFrom: e.detail.bookingFrom,
      bookingTo: e.detail.bookingTo,
      _submit: 1,
    });

    const extraParamsRaw = document.getElementById("locationForm")?.dataset.extraParams;
    if (extraParamsRaw) {
      try {
        const extraParams = JSON.parse(extraParamsRaw);
        Object.entries(extraParams).forEach(([key, value]) => {
          params.append(key, String(value ?? ""));
        });
      } catch (err) {
        console.error("Failed to parse extra search params", err);
      }
    }

    window.location = `${url}?${params.toString()}`;
  });
});
